'use client';
import React, { MouseEvent, ReactElement, useState } from 'react';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import subDays from 'date-fns/subDays';
import { Button, Icon, IconButton } from 'ui-components';
import DayCalendarPopover from '../day-calendar-popover';
import { DAY_BUTTON_SX, DAY_LABEL_FORMAT } from './day-navigator.constants';
import { DayNavigatorProps } from './day-navigator.props';

const DayNavigator = (props: DayNavigatorProps): ReactElement => {
  const { date, onChange } = props;
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<HTMLElement | null>(null);
  const dayLabel = format(date, DAY_LABEL_FORMAT, { locale: fr });

  const handleOpenCalendar = (event: MouseEvent<HTMLElement>) => {
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCloseCalendar = () => {
    setCalendarAnchorEl(null);
  };

  const handleSelectDay = (day: Date) => {
    onChange(day);
    handleCloseCalendar();
  };

  return (
    <>
      <IconButton
        data-testid="previous-day-button"
        aria-label="Jour précédent"
        onClick={() => onChange(subDays(date, 1))}
        size="large"
      >
        <Icon name="left-arrow" />
      </IconButton>
      <Button
        data-testid="current-date"
        aria-haspopup="dialog"
        color="tertiary"
        size="small"
        startIcon={<Icon name="calendar" size="small" />}
        onClick={handleOpenCalendar}
        sx={DAY_BUTTON_SX}
      >
        {dayLabel}
      </Button>
      <IconButton
        data-testid="next-day-button"
        aria-label="Jour suivant"
        onClick={() => onChange(addDays(date, 1))}
        size="large"
      >
        <Icon name="right-arrow" />
      </IconButton>
      <DayCalendarPopover
        anchorEl={calendarAnchorEl}
        date={date}
        onClose={handleCloseCalendar}
        onSelectDay={handleSelectDay}
      />
    </>
  );
};

export default DayNavigator;
